module.exports = __webpack_public_path__ + "img/wander2.bcfba76e.jpg";